import { publish } from '@wh/message-bus';
import { isNative } from './utils/isNative';
import { HEADER_PROPS_UPDATE_REQUESTED } from './constants';

const noop = () => {};

function filterPlugins(plugins, { deviceType }) {
  const key = isNative() ? `${deviceType}Native` : deviceType;
  return plugins.filter((p) => !p[2] || p[2][key]);
}

export const makePluginsRunner = ({
  plugins: allPlugins,
  productConfig,
  locale,
  deviceType,
  headerType,
  header,
  headerRenderers,
  pluginsRegistry,
}) => {
  Object.keys(pluginsRegistry).forEach((pluginName) => {
    const pluginImplementation = pluginsRegistry[pluginName];
    pluginImplementation.beforeRender = pluginImplementation.beforeRender || noop;
    pluginImplementation.afterRender = pluginImplementation.afterRender || noop;
  });

  const updateHeaderProps = (state) => publish(HEADER_PROPS_UPDATE_REQUESTED, state);

  const plugins = filterPlugins(allPlugins, { deviceType });
  return {
    beforeRender() {
      plugins.forEach((plugin) => {
        const pluginName = plugin[0];
        const pluginImplementation = pluginsRegistry[pluginName];

        pluginImplementation.beforeRender({
          productConfig,
          locale,
          deviceType,
          headerType,
          header,
          headerRenderers,
          params: plugin[1],
          updateHeaderProps,
        });
      });
    },

    afterRender() {
      plugins.forEach((plugin) => {
        const pluginName = plugin[0];
        const pluginImplementation = pluginsRegistry[pluginName];

        pluginImplementation.afterRender({
          productConfig,
          locale,
          deviceType,
          headerType,
          header,
          headerRenderers,
          params: plugin[1],
          updateHeaderProps,
        });
      });
    },
  };
};
